import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as rseeActions from '../../../redux/rseeDiscounts/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../components/loading';
import ENUMS from '../../../enums';
import { enumHelper } from '../../../utils';
import styles from '../styles.scss';
import { formatter } from '../../../utils';

const renderStatusColors = status => {
  const { REQUESTED, REJECTED, CONFIRMED } = ENUMS.RSEE_DISCOUNTS_STATUS.values;
  switch (status) {
    case REQUESTED:
      return 'text-muted';
    case CONFIRMED:
      return 'text-success';
    case REJECTED:
      return 'text-danger';
    default:
      return 'text-info';
  }
};

const RseeDiscountRequestDetailsById = props => {
  useEffect(() => {
    props.fetchRseeDiscountRequestDetailsById(props.discountId);
  }, []);

  const {
    rseeDiscountRequestDetailsByIdLoading,
    rseeDiscountRequestDetailsByIdError,
    rseeDiscountRequestDetailsByIdFailed,
    rseeDiscountRequestDetailsByIdMessage,
    rseeDiscountRequestDetailsById,
  } = props;

  const {
    rseeDiscountItems,
    rseeName,
    createdAt,
    currency,
    createdFullName,
    fromDate,
    toDate,
    rejectionReason,
    respondedAt,
    respondedFullName,
    status,
  } = rseeDiscountRequestDetailsById;

  const discountDays =
    rseeDiscountItems && rseeDiscountItems.length
      ? [...new Set(rseeDiscountItems.map(item => item.weekday))]
      : [];

  return (
    <>
      <Modal id='financial-transaction-modal' size='xl' isOpen={props.isOpen}>
        <ModalHeader>
          <div className='row'>
            <div className='col-11'>
              {locales('titles.rseeDiscountRequestDetails')}
            </div>
            <div className='col-1 text-left'>
              <a
                href='#'
                className=''
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className='fas fa-times'></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={rseeDiscountRequestDetailsByIdLoading}>
            {rseeDiscountRequestDetailsByIdError && (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            )}
            {rseeDiscountRequestDetailsByIdFailed && (
              <div className='alert alert-danger'>
                {rseeDiscountRequestDetailsByIdMessage}
              </div>
            )}
            <article className='col-12'>
              <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                {locales('titles.disocuntBasicInfo')}
              </div>

              <div className='col-12 border rounded py-2 px-1'>
                <div className='col-12 d-flex py-2 px-1'>
                  <div className='col-4 d-flex align-items-center'>
                    <div className='col-5 text-muted'>
                      {locales('titles.creatorName')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {createdFullName}
                    </div>
                  </div>
                  <div className='col-4 d-flex justify-content-end align-items-center p-0'>
                    <div className='col-5 text-left text-muted'>
                      {locales('tables.respondedAt')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {respondedAt}
                    </div>
                  </div>
                  <div className='col-4 d-flex justify-content-end align-items-center p-0'>
                    <div className='col-5 text-muted'>
                      {locales('tables.status')} :{' '}
                    </div>
                    <div
                      className={`${renderStatusColors(
                        status,
                      )} col-7 text-dark font-weight-bold font-large`}
                    >
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.RSEE_DISCOUNTS_STATUS.list,
                        status,
                      )}
                    </div>
                  </div>
                </div>

                <div className='col-12 d-flex py-2 px-1 my-2'>
                  <div className='col-4 d-flex  align-items-center'>
                    <div className='col-5 text-muted'>
                      {locales('fields.requestTime')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {createdAt}
                    </div>
                  </div>

                  <div className='col-4 d-flex align-items-center'>
                    <div className='col-5 text-muted text-center mx-2'>
                      {locales('fields.rsee.name')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {rseeName}
                    </div>
                  </div>
                  <div className='col-4 d-flex align-items-center p-0'>
                    <div className='col-6 text-muted'>
                      {locales('tables.respondedFullName')} :{' '}
                    </div>
                    <div className='col-6 text-dark font-weight-bold font-large'>
                      {respondedFullName}
                    </div>
                  </div>
                </div>

                <div className='col-12 d-flex py-2 px-1 my-2'>
                  <div className='col-4 d-flex  align-items-center'>
                    <div className='col-5 text-muted'>
                      {locales('tables.creditFrom')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {fromDate}
                    </div>
                  </div>

                  <div className='col-4 d-flex align-items-center'>
                    <div className='col-5 text-muted text-center mx-2'>
                      {locales('tables.creditTo')} :{' '}
                    </div>
                    <div className='col-7 text-dark font-weight-bold font-large'>
                      {toDate}
                    </div>
                  </div>
                  <div className='col-4 d-flex align-items-center p-0'>
                    <div className='col-6 text-muted'>
                      {locales('labels.rejectionReason')} :{' '}
                    </div>
                    <div className='col-6 text-dark font-weight-bold font-large'>
                      {rejectionReason}
                    </div>
                  </div>
                </div>
              </div>

              <table
                className={`table table-striped table-hover table-light table-bordered my-3  ${styles['table-row-overflow']}`}
              >
                <thead>
                  <tr>
                    <th className='text-center'>
                      {locales('fields.week.day')}
                    </th>
                    <th className='text-center'>
                      {locales('fields.discounts')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {discountDays.map(discount => (
                    <tr key={discount}>
                      <td className='text-center'>
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.WEEK_DAYS.list,
                          discount,
                        )}
                      </td>
                      <td className='text-center'>
                        <div className='d-flex justify-content-center'>
                          {[
                            ...rseeDiscountItems.filter(
                              item => item.weekday == discount,
                            ),
                          ].map(item => (
                            <React.Fragment key={item.id}>
                              <div className='px-3'>
                                <div className='px-3'>
                                  {`${item.toTime}-${item.fromTime}`}
                                </div>
                                <div className='px-3 flex-column'>
                                  {`${formatter.numberWithCommas(
                                    item.discountValue,
                                  )} ${
                                    item.discountType ===
                                    ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values
                                      .PERCENT
                                      ? enumHelper.convertEnumValueToTitle(
                                          ENUMS.CAFE_DISCOUNT_VALUE_TYPES.list,
                                          item.discountType,
                                        )
                                      : enumHelper.convertEnumValueToTitle(
                                          ENUMS.MONEY_UNITS.list,
                                          currency,
                                        )
                                  }`}
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-light' onClick={() => props.closeModal()}>
            {locales('labels.close.modal')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  return {
    rseeDiscountRequestDetailsById:
      state.rseeDiscountsReducer.rseeDiscountRequestDetailsById || {},
    rseeDiscountRequestDetailsByIdLoading:
      state.rseeDiscountsReducer.rseeDiscountRequestDetailsByIdLoading,
    rseeDiscountRequestDetailsByIdMessage:
      state.rseeDiscountsReducer.rseeDiscountRequestDetailsByIdMessage,
    rseeDiscountRequestDetailsByIdFailed:
      state.rseeDiscountsReducer.rseeDiscountRequestDetailsByIdFailed,
    rseeDiscountRequestDetailsByIdError:
      state.rseeDiscountsReducer.rseeDiscountRequestDetailsByIdError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchRseeDiscountRequestDetailsById: id =>
      dispatch(rseeActions.fetchRseeDiscountRequestDetailsById(id)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RseeDiscountRequestDetailsById);
